export { ThemeProvider, withStyles, withTheme } from '@material-ui/styles'

export * from '@material-ui/core/styles'
export { getLuminance, lighten } from '@material-ui/core/styles/colorManipulator'
export { dark, light } from '@material-ui/core/styles/createPalette'
